import React, { useState, useEffect } from 'react';
import './Spinner.css';  // Import the updated CSS file

const PopupCavm = () => {
  const [isProcessing, setIsProcessing] = useState(true);
  const [timer, setTimer] = useState(0); // Timer in seconds
  const [message, setMessage] = useState('Data Processing...');

  useEffect(() => {
    // Set up a timer that updates every second
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer + 1);
    }, 1000);

    // Stop the timer and update the message after 5 seconds (for example)
    setTimeout(() => {
      clearInterval(interval);
      setIsProcessing(false);
      
    }, 200000); // Adjust the time as needed

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

    const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // eslint-disable-next-line no-restricted-globals
      setIsMobile(screen.width <= 680);
    };
 
    handleResize(); // run initially
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`loading-container   ${isMobile ? 'top-[15%] left-[50%]' : 'top-[50%] left-[40%]'}`}>
      {isProcessing ? (
        <>
          <div className="loading-text p-[2rem] align-center text-center">Switch projection to display the dataset.</div>
        </>
      ) : (
        <div className="loading-text">{message}</div>
      )}
    </div>
  );
};

export default PopupCavm;
